import SVTooltip from '@pkgs/shared-client/components/SVTooltip';
import React, { forwardRef, useRef } from 'react';
import wrapDisplayName from 'recompose/wrapDisplayName';

export type Props = {
	showTooltipError: (error: Error | undefined | null) => void;
};

const SVWithTooltipErrorBoundary = <P,>(WrappedComponent: React.ComponentType<P & Props>) => {
	const WithTooltipErrorBoundary = forwardRef<any, Omit<P, 'showTooltipError'>>((props, ref) => {
		const elementRef = useRef<HTMLElement>(null);

		const showTooltipError: Props['showTooltipError'] = (error) => {
			if (!error || !elementRef.current) {
				return;
			}

			SVTooltip.show(elementRef.current, `An error ocurred.<br>${error.message}`);
		};

		return <WrappedComponent ref={ref} showTooltipError={showTooltipError} {...(props as P)} />;
	});

	WithTooltipErrorBoundary.displayName = wrapDisplayName(
		WrappedComponent,
		'SVWithTooltipErrorBoundary',
	);

	return WithTooltipErrorBoundary;
};

export default SVWithTooltipErrorBoundary;
